import { render, staticRenderFns } from "./EditPersonalInfo.vue?vue&type=template&id=f0abe896&scoped=true&"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./EditPersonalInfo.vue?vue&type=style&index=0&id=f0abe896&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0abe896",
  null
  
)

export default component.exports